//@ts-nocheck
export const DEFAULT_TEMPLATE_NAME = 'Crios';
export const DEFAULT_TEMPLATE_HEADING_FONT = 'Inter';
export const DEFAULT_TEMPLATE_BODY_FONT = 'Inter';
export const DEFAULT_TEMPLATE_COLOR = '#0D69D4';

export const parseTemplateSettingValue = (settingValue) => {
  if (!settingValue) return {};

  try {
    const parsedValue =
      typeof settingValue === 'string'
        ? JSON.parse(settingValue)
        : settingValue;
    const templateSettings = Array.isArray(parsedValue)
      ? parsedValue[0]
      : parsedValue;

    return templateSettings && typeof templateSettings === 'object'
      ? templateSettings
      : {};
  } catch {
    return {};
  }
};

export const resolveTemplateSettings = ({
  globalSettingValue,
  tripSettingValue,
  useTripTemplate = false
}) => {
  const globalSettings = parseTemplateSettingValue(globalSettingValue);
  const tripSettings = useTripTemplate
    ? parseTemplateSettingValue(tripSettingValue)
    : {};

  return {
    name: useTripTemplate
      ? tripSettings.name || globalSettings.name || DEFAULT_TEMPLATE_NAME
      : globalSettings.name || DEFAULT_TEMPLATE_NAME,
    headingfont: globalSettings.headingfont || DEFAULT_TEMPLATE_HEADING_FONT,
    bodyfont: globalSettings.bodyfont || DEFAULT_TEMPLATE_BODY_FONT,
    color: globalSettings.color || DEFAULT_TEMPLATE_COLOR,
    // The trip endpoint may return the global record, so only marked values override it.
    cherryServicesExpanded:
      useTripTemplate &&
      tripSettings.cherryServicesExpandedOverride === true &&
      typeof tripSettings.cherryServicesExpanded === 'boolean'
        ? tripSettings.cherryServicesExpanded
        : globalSettings.cherryServicesExpanded === true,
    showImagesInPdf: tripSettings.showImagesInPdf !== false,
    showOperatorInfo: useTripTemplate
      ? tripSettings.showOperatorInfo !== false
      : true
  };
};
